define('v3/Common/Services/gradeService',['v3/Common/Services/Backend/gradeBackend'], function (backend) {
	return {
		getGradesForSchool: function () {
			return backend.getGradesForSchool();
		}
	};
});

